<template>
  <div class="tv-org-search">
    <van-search v-model="searchValue" placeholder="请输入名称搜索" />
    <div class="content" v-if="showResult">
      <template v-if="list.length === 0">
        <div class="empt">
          <img style="width: 60%" src="@/assets/image/search-_empt.svg" alt="" />
          <p style="color: #b3b3b3">没有找到相关内容</p>
        </div>
      </template>
      <div v-else class="item-list">
        <div @click="handle2Back(org)" class="item" v-for="org in list" :key="org.id">
          <van-icon size="20" name="search" />
          <span>{{ org.orgName }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {tvGetorgs} from '@/api'
export default {
  data() {
    return {
      showResult: false,
      searchValue: '',
      list: []
    }
  },
  watch: {
    searchValue() {
      this.search()
    }
  },
  created() {
    const {code, servicePath, tenantId, orgId, orgName, name} = this.$route.query
    this.code = code
    this.servicePath = decodeURIComponent(servicePath)
    this.tenantId = tenantId
    this.orgId = orgId
    this.orgName = orgName
    this.name = name

    if (orgName) {
      this.searchValue = orgName
      // this.search()
    }
  },
  methods: {
    async search() {
      this.showResult = false
      if (!this.searchValue) return
      const params = {
        name: this.searchValue,
        tenantId: this.tenantId
      }
      const result = await tvGetorgs(params)
      this.list = result.data
      this.showResult = true
    },
    handle2Back({id, orgName}) {
      this.$router.replace({
        path: '/tv/binding',
        query: {
          code: this.code,
          servicePath: encodeURIComponent(this.servicePath),
          tenantId: this.tenantId,
          orgId: id,
          orgName: orgName,
          name: this.name
        }
      })
    }
  }
}
</script>

<style scoped lang="scss">
.tv-org-search {
  height: 100vh;
  background: #fff;
  display: flex;
  flex-direction: column;
  .content {
    height: 0;
    flex: 1;
    overflow-y: auto;
    .empt {
      text-align: center;
    }
  }
}
.item-list {
  padding: 16px;
  .item {
    display: flex;
    align-items: center;
    height: 50px;
    border-bottom: 1px solid #e6e6e6;
    span {
      margin-left: 6px;
      flex: 1;
      color: #4d4d4d;
    }
  }
}
</style>
